import React, { useState } from 'react'

import Header from './Header'
import { useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import Swal from 'sweetalert2'
import ReactLoading from 'react-loading';
import config from "../../config"
import Moment from 'react-moment';
import TablePagination from '@mui/material/TablePagination';
import { useNetworkState } from 'react-use';
import Footer from './Footer';
import moment from 'moment'
import $ from 'jquery'; 
import 'daterangepicker/daterangepicker.css'; // Import daterangepicker CSS
import 'daterangepicker';

const International_action = () => {
const shipment_id = useParams();
console.log("shipment_id == " , shipment_id)
const[state, setState] = React.useState([])
const[hubstate, sethubState] = React.useState([])
 const[addressState, setaddressState] = React.useState([]);
 const [selectedAddressId, setSelectedAddressId] = useState(null);
let userDetail = localStorage.getItem('ship_rocket_user');
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }
React.useEffect(()=>{
    shipment_tracking()
    dropHub()
    address_book_detail()
},[])
const shipment_tracking = () =>{
      
    let full_api = config.apiUrl + `/shipment/shipment_detail`;
   let sendData = {customer_id:userData.customer_id , shipment_id:shipment_id.shipment_id};
   // console.log("sendData",sendData)
    
   axios.post(full_api, sendData, { headers: config.headers }).then(res => {
    if(res.data.status==200){
       setState( res.data.output)
      }
    else{

    }
   
    
   }).catch((e) => {
     // toast.configure()
      //toast.error("Some thing went wrong")
     // console.log("----error:   ", e);
   })
 }

 const dropHub = () =>{
      
    let full_api = config.apiUrl + `/shipment/available_drop_hub`;
   let sendData = {customer_id:userData.customer_id , shipment_id:shipment_id.shipment_id};
   // console.log("sendData",sendData)
    
   axios.post(full_api, sendData, { headers: config.headers }).then(res => {
    if(res.data.status==true){
        sethubState( res.data.output)
      }
    else{

    }
   
    
   }).catch((e) => {
     // toast.configure()
      //toast.error("Some thing went wrong")
     // console.log("----error:   ", e);
   })
 }

 const update_self_ship = () =>{
      
    let full_api = config.apiUrl + `/shipment/update_int_action`;
   let sendData = {customer_id:userData.customer_id , shipment_id:shipment_id.shipment_id};
   // console.log("sendData",sendData)
    
   axios.post(full_api, sendData, { headers: config.headers }).then(res => {
    if(res.data.status==true){
         const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000
            })
              Toast.fire({
              background:"#3659cd",
              type: 'success',
              title: "Update Successfully",
              color:"white"
            });
       window.location.replace(`/intl_action_2/${shipment_id.shipment_id}`)
      }
    else{
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
            Toast.fire({
            background:"#a61c09",
            type: 'unsuccess',
            title: "Something Went Wrong",
            color:"white"
          });
    }
   
    
   }).catch((e) => {
     // toast.configure()
      //toast.error("Some thing went wrong")
     // console.log("----error:   ", e);
   })
 }

 const address_book_detail = ()=>{
    let url = config.apiUrl + '/country/address_book';
    let sendData = {  customer_id: userData.customer_id };
    // console.log("bb", sendData);
    axios.post(url,sendData ,{headers:config.headers}).then((res)=>{
        if(res.data.status==true){
            // console.log("sasdfdsa")
            setaddressState(res.data.output)
        }
   }).catch(()=>{
    })
   }
   const handleRadioChange = (event) => {
    setSelectedAddressId(event.target.value);
  };


  const update_pickup = () =>{
      if(selectedAddressId!=null && selectedAddressId!=""){
    let full_api = config.apiUrl + `/shipment/update_int_action_pickup`;
   let sendData = {customer_id:userData.customer_id , shipment_id:shipment_id.shipment_id ,address_id:selectedAddressId };
   // console.log("sendData",sendData)
    
   axios.post(full_api, sendData, { headers: config.headers }).then(res => {
    if(res.data.status==true){
       window.location.replace(`/intl_action_2/${shipment_id.shipment_id}`)
      }
    else{
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
            Toast.fire({
            background:"#a61c09",
            type: 'unsuccess',
            title: "Something Went Wrong",
            color:"white"
          });
    }
   
    
   }).catch((e) => {
     // toast.configure()
      //toast.error("Some thing went wrong")
     // console.log("----error:   ", e);
   })
}else{
 const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              
              Toast.fire({
                background:"#a61c09",
                type: 'unsuccess',
                title: "Please Select A Warehouse To Proceed",
                color:"white"
              });
}
 }
  return (
    <div>
      <Header/>
    <div class="page-wrapper pinned">
    <div class="main-container">
      <div className='app-container'>
    <div class="app-body">



    <div class="mob_nav">
  <div class=" d-flex justify-content-start ">
    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
    <h2>{state.length>0?state[0].carrier_tracking_number:""}</h2>
  </div>
</div>


<div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>{state.length>0?state[0].carrier_tracking_number:""}</h2>
      </div>
    </div>
</div>



<div class="row">
    <div class="col-12 col-md-6">
        <div class="card border-0 mb-3">
            <div class="card-body">
                <div class="alert alert-warning">
                 Shipment has been booked but an action pending on this shipment to process. <br/>
                 <h3>Please choose the action below.</h3>
                </div>

            
                <ul class="nav nav-tabs justify-content-center">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#SelfShip">
                            <h4>Self Ship</h4>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#Pickup">
                            <h4>Pickup</h4>
                        </a>
                    </li>
                </ul>

                <div class="tab-content mt-3">
                    <div class="tab-pane container active" id="SelfShip">
                    <div class="alert alert-success">
                    <h6>If you want to use the self-ship service, please drop the shipment on below hub location.</h6>
                    </div>
                            
                        <h3>Avaiable Drop Hub</h3>
                        <hr/>
                        {hubstate.length>0?<>
                          {hubstate.map((item)=>(
                            <>
                        <h6>Address</h6>
                        <p>
                            {item.hub_address} , {item.hub_city} , {item.hub_state} , {item.hub_pincode}
                        </p>
                        <h6>Mobile Number</h6>
                        <p>
                            {item.hub_mobile}
                        </p>
                        <h6>Email</h6>
                        <p>
                            {item.hub_email}
                        </p>
                        </>
))}
                        <div class="d-grid">
                          <a onClick={(e)=>update_self_ship(e)} style={{cursor:"pointer"}} class="btn btn-primary btn-block">Proceed with Self-Ship service</a>
                        </div>
                        </>:"No Hub Available"}
                    </div>
                    <div class="tab-pane container fade" id="Pickup">
                    <div class="alert alert-success">
                    <h6>If you want to use the Pickup service and want us to pickup the shipment from your doorstep, please selecte a warehouse from where you want to do the shipment pickup.</h6>
                    </div>
                    
                        <div class="d-flex justify-content-between">
                            <h3>Please select warehouse</h3>
                            <a href="/warehouse" style={{cursor:"pointer"}} class="btn btn-primary">Create new warehouse</a>
                        </div>
                        <hr/>
                        <table class="table table-bordered">
                            {addressState.length>0?
                            <tbody>
                                {addressState.map((item)=>(
                              <tr>
                                <td>
                                <input
              type="radio"
              className="form-check-input"
              id={`radio-${item.address_id}`} // Unique ID for each radio button
              name="optradio"
              value={item.address_id} // Set value to address_id
              checked={selectedAddressId === item.address_id} // Check if this item is selected
              onChange={handleRadioChange} // Handle change
            />
                                </td>
                                <td>
                                    <h4>{item.warehouse_id?item.warehouse_id:item.warehouse_name}</h4>
                                    {item.address}, {item.city_name}, {item.state_name}, {item.country_name} - {item.pincode}</td>
                              </tr>
                              ))}
                            </tbody>
                            :"No Warehouse Available"}
                          </table>

                        <div class="d-grid">
                          <a onClick={(e)=>update_pickup(e)} style={{cursor:"pointer"}} class="btn btn-primary btn-block">Proceed with Pickup service</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="card border-0 mb-3">
          <div class="card-body">
              <div class="d-flex ">
                  <div class="border-end pe-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-l="" inejoin="round" data-lucide="truck" class="lucide lucide-truck"><path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"></path><path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"></path><circle cx="7" cy="18" r="2"></circle><path d="M15 18H9"></path><circle cx="17" cy="18" r="2"></circle></svg>
                  </div>
                  <div class="ps-3 ">
                      <h6>Shipping Details</h6>
                  </div>
              </div>
              <hr/>
              <div class="row">
                  <div class="col-12 col-md-4 mb-2 shipping_carrier_im">
                     {state.length>0? <img src="assets/images/carriers_logo/fedex.svg" alt="" class="img-fluid" title="Fedex Inc."/>:""}
                  </div>
                  <div class="col-6 col-md-4 mb-2">
                      <small class="text-muted">Shipment No.</small>
                      <p><strong><a href="">{state.length>0?state[0].shipment_id:""}</a></strong></p>
                  </div>
                  <div class="col-6 col-md-4 mb-2">
                      <small class="text-muted">Order on</small>
                   {state.length>0 ?  <p><Moment format="MMM DD YYYY">
                        {new Date(state[0].created*1000)}
            </Moment> - <Moment format="hh:mm:ss a">
                        {new Date(state[0].created*1000)}
            </Moment></p>:""}
                  </div>
                  <div class="col-6 col-md-4 mb-2">
                      <small class="text-muted">Shipping Courier</small>
                      <p>{state.length>0?state[0].service_provider:""}</p>
                  </div>
                  <div class="col-6 col-md-4 mb-2">
                      <small class="text-muted">Shipping Courier AWB No.</small>
                      <p><a href="">{state.length>0?state[0].carrier_tracking_number:""}</a></p>
                  </div>
                  <div class="col-6 col-md-4 mb-2">
                      <small class="text-muted">Shipping Courier Service</small>
                      <p>{state.length>0?state[0].int_mode:""}</p>
                  </div>
              </div>
          </div>
      </div>
    </div>
</div>

    </div>
    
    </div>
    <Footer/>
    </div>
    
   
    </div>
   
    </div>
  )
}

export default International_action
